import httpService from "..";

export const getUsersApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/user`,
    "get",
  );
};

export const getGroupsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/group`,
    "get",
  );
};

export const addUserApi = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/user`,
    "post",
    data
  );
};

export const addGroupApi = async (data: {}, userId: number) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/group?userId=${userId}`,
    "post",
    data
  );
};

export const getBalanceReconciliationApi = async (groupId: number) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/balance-reconciliation?groupId=${groupId}`,
    "get"
  );
};

export const fixPolicyBalanceApi = async (policyId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/fix-balance`,
    "post",
    { policyId }
  );
};
